<template>
  <button
    type="button"
    class="inline-flex h-16 w-16 items-center justify-center rounded-md text-gray-500 hover:text-gray-900 lg:hidden -mr-4"
    @click="openEvent"
  >
    <span class="sr-only">Open sidebar</span>
    <RenderTemplateSidebarBurguer />
  </button>

  <ClientOnly>
    <div v-if="sidebarLoad">
      <LazyRenderTemplateSidebarDialog
        :sidebar-open="sidebarOpen"
        @render-template-sidebar:close="closeEvent"
      >
        <template #body>
          <slot name="body" />
        </template>
        <template #footer>
          <slot name="footer" />
        </template>
      </LazyRenderTemplateSidebarDialog>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const sidebarLoad = ref(false)
const sidebarOpen = ref(false)

const openEvent = () => {
  sidebarLoad.value = true
  sidebarOpen.value = true
}

const closeEvent = () => {
  sidebarOpen.value = false
}
</script>
